<template>
  <v-app id="inspire">
    <v-navigation-drawer app clipped dark fixed v-model="drawer">
      <app-menu></app-menu>
    </v-navigation-drawer>

    <app-header v-model="drawer" />

    <v-main class="grey lighten-2">
      <v-progress-linear
        color="accent"
        :indeterminate="true"
        :active="showLoading"
        class="my-0"
        style="position: absolute;"
      />
      <app-page>
        <transition name="slide">
          <router-view></router-view>
        </transition>
      </app-page>
    </v-main>
    <v-footer app fixed>
      <v-row row wrap>
        <v-col>
          <span class="pl-2">&copy; {{ new Date().getFullYear() }}</span>
        </v-col>
        <v-col text-xs-center>
          <span class="pe-10" v-if="today"
            >Reference Date: <b>{{ today }}</b></span
          >
        </v-col>
        <v-col text-xs-right>
          <span class="mr-2" v-if="version">Version: {{ version }}</span>
        </v-col>
      </v-row>
    </v-footer>
    <confirm-view />
  </v-app>
</template>

<script>
"use strict";

import appHeader from "@/components/app-header.vue";
import appMenu from "@/components/app-menu.vue";
import appPage from "@/components/app-page.vue";
import { EventBus } from "@/bus";
import confirmView from "../views/dialogs/confirm.view.vue";

export default {
  components: {
    appHeader,
    appMenu,
    appPage,
    confirmView
  },
  computed: {
    version() {
      return process.env.VUE_APP_VERSION;
    }
  },
  data: () => ({
    drawer: true,
    showLoading: false,
    today: undefined
  }),
  created() {
    if (
      this.$store.state.auth.user.roles[0] ==
      this.$store.state.constants.roles.SECURITY
    ) {
      this.drawer = false;
    }
  },
  mounted() {
    window.addEventListener("beforeunload", () => {
      if (this.$store.$io != null && this.$store.$io.connected) {
        this.$store.commit("disconnect");
      }
    });

    if (
      this.$store.state.auth.user &&
      (!this.$store.$io || this.$store.$io != null)
    ) {
      this.$store.commit("connect", this.$store.state.auth.user);
    }

    EventBus.$on("showLoading", () => (this.showLoading = true));
    EventBus.$on("hideLoading", () => (this.showLoading = false));

    if (process.env.VUE_APP_REFERENCE_DATE) {
      this.today = process.env.VUE_APP_REFERENCE_DATE;
    }
  },
  props: {
    source: String
  }
};
</script>

<style scopped lang="scss">
.v-navigation-drawer {
  z-index: 1000 !important;
}

#layout-app {
  .header {
    position: absolute;
    z-index: 0;
    top: 0;
    right: 0;
    left: 0;
    height: 200px;
    background-image: url("~@/assets/images/backgrounds/header-bg.png");
    background-size: cover;
  }

  .table-container {
    padding: 0 16px 0 16px;
  }

  .table-container .layout-fixed table {
    table-layout: fixed;
    width: 100%;
    white-space: nowrap;
  }

  .table-container .layout-fixed th {
    background-color: #fff; /* just for LIGHT THEME, change it to #474747 for DARK */
    position: sticky;
    top: 0;
    z-index: 1;
  }

  .table-container .layout-fixed td {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .table-container .layout-fixed td.word-wrap {
    white-space: normal;
    overflow: unset;
    text-overflow: unset;
  }

  .table-container .layout-fixed tr.datatable__progress th {
    top: 56px;
  }

  .table-container .layout-fixed .v-table__overflow {
    overflow: unset !important;
    height: 100%;
  }

  .dont-break-out {
    /* These are technically the same, but use both */
    overflow-wrap: break-word;
    word-wrap: break-word;

    -ms-word-break: break-all;
    /* This is the dangerous one in WebKit, as it breaks things wherever */
    word-break: break-all;
    /* Instead use this non-standard one: */
    word-break: break-word;

    /* Adds a hyphen where the word breaks, if supported (No Blink) */
    -ms-hyphens: auto;
    -moz-hyphens: auto;
    -webkit-hyphens: auto;
    hyphens: auto;
  }
  .count-items {
    font-weight: bold;
    font-size: 1.1rem;
    margin: 20px 0 0px 0;
    padding-bottom: 5px;
  }
}

.v-datatable thead th.column {
  font-size: 17px;
  font-weight: normal;
}

thead.v-data-table-header .v-icon {
  display: inline;
}

/* doesnt work on safari */
.table-container .v-data-table {
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  min-height: 120px;
}

.v-btn {
  white-space: normal;
  word-break: normal;
}

.v-btn__content {
  width: 100%;
}
</style>
